import React from "react";

const Marquee = () => {
  return (
    <div
      className="marquee-container"
      role="region"
      aria-live="polite"
      aria-label="Marquee content showcasing dynamic titles"
    >
      <div className="marquee-wrapper">
        <span>Queen center</span>
        <span>Zelfvertrouwen</span>
        <span>Schoonheid</span>
        <span>Art</span>
        <span>Fillers</span>
      </div>
      <div className="marquee-wrapper" aria-hidden="true">
        <span>Queen center</span>
        <span>Zelfvertrouwen</span>
        <span>Schoonheid</span>
        <span>Art</span>
        <span>Fillers</span>
      </div>
    </div>
  );
};

export default Marquee;
